import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './ManagementPages.css';

const PublicKycUploadPage = () => {
  const { token } = useParams();
  const [documentType, setDocumentType] = useState('PAN');
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage('Please select a file');
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append('document', file);
    formData.append('documentType', documentType);

    try {
      const response = await fetch(`http://localhost:5001/api/kyc/upload/${token}`, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        setMessage(data.error || data.message || 'Upload failed');
        setSuccess(false);
      } else {
        setMessage(data.message || 'Document uploaded successfully!');
        setSuccess(true);
        setFile(null);
        setDocumentType('PAN');
      }
    } catch (err) {
      setMessage('Error uploading: ' + err.message);
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>📄 KYC Document Upload</h1>
        <p style={styles.subtitle}>Scan this link from your mobile and upload your documents</p>

        {message && (
          <div style={{ ...styles.alert, backgroundColor: success ? '#d4edda' : '#f8d7da' }}>
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Document Type</label>
            <select
              value={documentType}
              onChange={(e) => setDocumentType(e.target.value)}
              style={styles.select}
            >
              <option value="PAN">PAN Card</option>
              <option value="AADHAAR">Aadhaar Card</option>
              <option value="SHOP_IMAGE">Shop Image</option>
              <option value="SELFIE">Selfie</option>
              <option value="ELECTRICITY_BILL">Electricity Bill</option>
            </select>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Select File</label>
            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={handleFileChange}
              style={styles.input}
              required
            />
            <small style={styles.helpText}>Allowed: PDF, JPG, JPEG, PNG (Max 5MB)</small>
          </div>

          {file && (
            <div style={styles.fileInfo}>
              <p>Selected: {file.name}</p>
              <p>Size: {(file.size / 1024).toFixed(2)} KB</p>
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{ ...styles.button, opacity: loading ? 0.6 : 1 }}
          >
            {loading ? 'Uploading...' : 'Upload Document'}
          </button>
        </form>

        <div style={styles.info}>
          <h3>📝 Instructions:</h3>
          <ul>
            <li>Select the document type from the dropdown</li>
            <li>Choose a file (PDF or Image)</li>
            <li>Click "Upload Document"</li>
            <li>Upload PAN and Aadhaar to auto-verify KYC</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    padding: '20px',
    fontFamily: 'Inter, sans-serif',
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    padding: '40px',
    maxWidth: '500px',
    width: '100%',
  },
  title: {
    fontSize: '28px',
    fontWeight: '600',
    marginBottom: '8px',
    color: '#333',
    textAlign: 'center',
  },
  subtitle: {
    fontSize: '14px',
    color: '#666',
    textAlign: 'center',
    marginBottom: '24px',
  },
  alert: {
    padding: '12px',
    borderRadius: '8px',
    marginBottom: '20px',
    fontSize: '14px',
    textAlign: 'center',
  },
  form: {
    marginBottom: '24px',
  },
  formGroup: {
    marginBottom: '20px',
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '8px',
    color: '#333',
  },
  select: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    fontFamily: 'Inter, sans-serif',
  },
  input: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
  },
  helpText: {
    display: 'block',
    marginTop: '6px',
    color: '#999',
    fontSize: '12px',
  },
  fileInfo: {
    backgroundColor: '#f9f9f9',
    padding: '12px',
    borderRadius: '6px',
    marginBottom: '16px',
    fontSize: '13px',
  },
  button: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
  info: {
    backgroundColor: '#f0f8ff',
    padding: '16px',
    borderRadius: '8px',
    fontSize: '13px',
    lineHeight: '1.6',
  },
};

export default PublicKycUploadPage;
